import { TransactionRelationshipSelectOptions } from '@/modules/accounting/models/TransactionRelationshipSelectOptions';
import { transactionRelationshipSelectOptions } from '@/modules/accounting/store/accounting.state';

export function getTransactionRelationshipSelectOptions():
  | TransactionRelationshipSelectOptions
  | undefined {
  return transactionRelationshipSelectOptions.value;
}
